import classNames from "classnames";
import { AttachmentImage } from "./AttachmentImage";
import { ImageAttachmentData } from "~/models/card";

/**
 * AttachmentImage
 *
 * This component is used to display an image
 *
 * @param {number} imageId The ID of the image to display.
 * @param {string} imagePosition (optional) The position of the image within its container.
 * @param {React.CSSProperties} style (optional) Additional styles to apply to the image.
 * @param {string} className (optional) Additional class names to apply to the image.
 * @returns {*} React JSX
 */
export function AttachmentImageFull({
  image,
  imagePosition,
  style,
  className,
}: {
  image?: ImageAttachmentData;
  imagePosition?: string;
  style?: React.CSSProperties;
  className?: string;
}) {
  return (
    <AttachmentImage
      image={image}
      imagePosition={imagePosition}
      style={style}
      className={classNames("tw:object-cover tw:!h-full tw:!w-full", className)}
    />
  );
}
